/**
 * `flag(name)` for a component: the same one reader, subscribed, so the surface re-renders when a
 * new document lands (R9 §8 S3 — "memoized `flag()` and the re-render on a new document").
 *
 * The snapshot is a boolean, so reference stability is free, and the value is read from the
 * store's already-resolved map — no evaluation happens per render.
 */

import { useSyncExternalStore } from 'react'
import type { FlagName } from '@selogate/core'
import { flag, subscribeToClientConfig } from './store'

export function useFlag(name: FlagName): boolean {
  return useSyncExternalStore(
    subscribeToClientConfig,
    () => flag(name),
    () => flag(name),
  )
}
